<div class="assistants-container">
  @if (!editingAssistant) {
    <div class="assistants-table">
      <input
        pInputText
        placeholder="Filter by name"
        class="assistants-filter w-full"
        [(ngModel)]="filterText"
        />
      <p-table
        [value]="filteredAssistants"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        >
        <ng-template pTemplate="colgroup">
          <colgroup>
          <col style="width: 28rem" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Edit</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-assistant>
        <tr>
          <td class="id-cell">
            <span class="id-text">{{ assistant?.id }}</span>
          </td>
          <td>{{ assistant?.name }}</td>
          <td>
            <p-button
              icon="pi pi-pencil"
              class="p-button-outlined"
              (click)="startEdit(assistant)"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}

@if (editingAssistant) {
  <div class="assistant-edit-panel">
    <div class="edit-header">
      <p-button
        icon="pi pi-arrow-left"
        class="p-button-text"
        (click)="goBack()"
      ></p-button>
      <h4>Edit Assistant</h4>
    </div>
    <form [formGroup]="formGroup" class="assistants-form">
      <div class="form-section">
        <div class="form-field">
          <label class="field-label"><strong>ID</strong></label>
          <div class="field-content">
            <div class="field-value">{{ editingAssistant?.id }}</div>
          </div>
        </div>
        <div class="form-field">
          <label for="name" class="field-label"><strong>Label</strong></label>
          <div class="field-content">
            <input id="name" pInputText formControlName="name" class="w-full" />
          </div>
        </div>
        <div class="form-field">
          <label for="shortDescription" class="field-label"
            ><strong>Short Summary</strong></label
            >
            <div class="field-content">
              <input
                id="shortDescription"
                pInputText
                formControlName="shortDescription"
                class="w-full"
                />
            </div>
          </div>
          <div class="form-field">
            <label for="longDescription" class="field-label"
              ><strong>Summary</strong></label
              >
              <div class="field-content">
                <textarea
                  id="longDescription"
                  formControlName="longDescription"
                  pTextarea
                  rows="4"
                  class="w-full"
                ></textarea>
              </div>
            </div>
            <div class="form-field">
              <label for="color" class="field-label"><strong>Color</strong></label>
              <div class="field-content">
                <p-colorPicker
                  id="color"
                  formControlName="color"
                  styleClass="w-full"
                ></p-colorPicker>
              </div>
            </div>
            <label for="longDescription" class="field-label"
              ><strong>Model</strong></label
              >
              <div class="form-field">
                <label for="modelName" class="field-label">Model name</label>
                <input
                  formControlName="modelName"
                  pInputText
                  id="modelName"
                  name="modelName"
                  type="text"
                  />
              </div>
              <div class="form-field">
                <label for="modelTopK" class="field-label">Top K</label>
                <p-inputnumber
                  formControlName="modelTopK"
                  id="modelTopK"
                  name="modelTopK"
            pTooltip="Valor bajo, más precisión y menos diversidad. Valor alto, más
  diversidad y menos precisión."
                  tooltipPosition="bottom"
                  required
                  />
              </div>
              <div class="form-field">
                <label for="modelTopP" class="field-label">Top P</label>
                <p-inputnumber
                  formControlName="modelTopP"
                  mode="decimal"
                  locale="en-US"
                  [minFractionDigits]="1"
                  id="modelTopP"
                  name="modelTopP"
                  pTooltip="Valor bajo, más focalizado y conservativo. Trabaja con el Top K."
                  tooltipPosition="bottom"
                  required
                  />
              </div>
              <div class="form-field">
                <label for="temperature" class="field-label">Temperature</label>
                <p-inputnumber
                  formControlName="temperature"
                  id="temperature"
                  name="temperature"
                  pTooltip="Valor bajo, más realista y menos alucinaciones."
                  tooltipPosition="bottom"
                  required
                  />
              </div>
              <p-divider />
              <label for="longDescription" class="field-label"
                ><strong>Retrieving</strong></label
                >
                <div class="form-field">
                  <label for="topK" class="field-label">Top K</label>
                  <p-inputnumber
                    formControlName="topK"
                    id="topK"
                    name="topK"
                    pTooltip="Número de chunks en el contexto."
                    tooltipPosition="bottom"
                    required
                    />
                </div>
                <div class="form-field">
                  <label for="memoryMessages" class="field-label"
                    >Memory messages</label
                    >
                    <p-inputnumber
                      formControlName="memoryMessages"
                      id="memoryMessages"
                      name="memoryMessages"
                      pTooltip="Número de mensajes en la memoria."
                      tooltipPosition="bottom"
                      required
                      />
                  </div>
                  <p-divider />
                  <div class="form-field">
                    <label class="field-label"><strong>Prompt</strong></label>
                    <textarea
                      formControlName="prompt"
                      pTextarea
                      fluid
                      rows="5"
                      cols="30"
                      id="prompt"
                      name="prompt"
                      required
                      class="prompt-textarea"
                      >
                    </textarea>
                  </div>
                  <label class="field-label"><strong>Visual Settings</strong></label>
                  <div class="form-field">
                    <div class="field-content">
                      <p-checkbox
                        formControlName="showFAQs"
                        [binary]="true"
                        inputId="showFAQs"
                      ></p-checkbox>
                      <label for="showFAQs" class="checkbox-label"
                        >Show Frequently Asked Questions</label
                        >
                      </div>
                    </div>
                    <div class="form-field">
                      <div class="field-content">
                        <p-checkbox
                          formControlName="showThumbs"
                          [binary]="true"
                          inputId="showThumbs"
                        ></p-checkbox>
                        <label for="showThumbs" class="checkbox-label"
                          >Show Thumbs Up/Down Buttons</label
                          >
                        </div>
                      </div>
                      <div class="form-field">
                        <div class="field-content">
                          <p-checkbox
                            formControlName="showContext"
                            [binary]="true"
                            inputId="showContext"
                          ></p-checkbox>
                          <label for="showContext" class="checkbox-label"
                            >Show Context Information</label
                            >
                          </div>
                        </div>
                        <div class="form-field">
                          <div class="field-content">
                            <p-checkbox
                              formControlName="showSources"
                              [binary]="true"
                              inputId="showSources"
                            ></p-checkbox>
                            <label for="showSources" class="checkbox-label"
                              >Show Source Information</label
                              >
                            </div>
                          </div>
                          <div class="form-field">
                            <div class="field-content">
                              <p-checkbox
                                formControlName="showWelcomeMessage"
                                [binary]="true"
                                inputId="showWelcomeMessage"
                              ></p-checkbox>
                              <label for="showWelcomeMessage" class="checkbox-label"
                                >Show Welcome Message</label
                                >
                              </div>
                            </div>
                            <div class="form-field">
                              <label for="welcomeMessage" class="field-label"
                                ><strong>Welcome Message</strong></label
                                >
                                <textarea
                                  id="welcomeMessage"
                                  formControlName="welcomeMessage"
                                  pTextarea
                                  rows="10"
                                  class="w-full"
                                ></textarea>
                              </div>
                              <div class="form-field">
                                <label for="safeguard" class="field-label"
                                  ><strong>Safeguard Message</strong></label
                                  >
                                  <textarea
                                    id="safeguard"
                                    formControlName="safeguard"
                                    pTextarea
                                    rows="10"
                                    class="w-full"
                                  ></textarea>
                                </div>
                                <div class="form-field">
                                  <label for="FAQs" class="field-label"
                                    ><strong>FAQ List</strong></label
                                    >
                                    <textarea
                                      id="FAQs"
                                      formControlName="FAQs"
                                      pTextarea
                                      rows="6"
                                      class="w-full"
                                      placeholder="Enter one FAQ per line"
                                    ></textarea>
                                    <small class="field-help"
                                      >Enter one FAQ per line. These will be displayed as suggested
                                      questions.</small
                                      >
                                    </div>
                                  </div>
                                  <div class="form-actions">
                                    <p-button
                                      label="Save Settings"
                                      icon="pi pi-check"
                                      (onClick)="onSaveClick()"
                                      [loading]="isLoading"
                                      [disabled]="isSaveDisabled()"
                                      class="save-button"
                                    ></p-button>
                                  </div>
                                </form>
                              </div>
                            }
                          </div>
